import { FC } from "react";
import styled from "styled-components";

import { Modal } from "@/components/Modal";
import ProgressBar from "@/components/ProgressBar";
import Text from "@/components/Text";

const ProgressHolder = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  padding: 16px;
`;

const ProgressModal = styled.div`
  padding: 32px 24px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
`;

const StyledProgressBar = styled(ProgressBar)`
  height: 12px;
  width: 420px;
`;

const ProgressTexts = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
`;

interface Props {
  progressPercent: number;
}
const ThumbnailsDownloadProgress: FC<Props> = ({ progressPercent }) => {
  return (
    <Modal>
      <ProgressModal>
        <ProgressHolder>
          <StyledProgressBar progress={progressPercent} color="primary" />
          <ProgressTexts>
            <Text $type="smallHeadline">Preparing to download ...</Text>
            <Text $type="smallHeadline">{progressPercent} %</Text>
          </ProgressTexts>
        </ProgressHolder>
      </ProgressModal>
    </Modal>
  );
};

export default ThumbnailsDownloadProgress;
